import { Box, Chip, Stack } from "@mui/material";
import ToolTip from "../../ToolTip/ToolTip";

export const CART_EDIT_TABLE_HEAD = [
  { field: "sl_no", headerName: "Sl No", width: 100 },
  {
    field: "request_title",
    headerName: "Title",
    width: 250,
    renderCell: (params) => {
      return (
        <ToolTip
          content={params.row.request_title}
          expand={params.row.request_title}
        />
      );
    },
  },
  {
    field: "course_name",
    headerName: "Course Name",
    width: 250,
    renderCell: (params) => {
      return (
        <ToolTip
          content={params.row.course_name}
          expand={params.row.course_name}
        />
      );
    },
  },
  {
    field: "request_body",
    headerName: "Description",
    width: 250,
    renderCell: (params) => {
      return (
        <ToolTip
          content={params.row.request_body}
          expand={params.row.request_body}
        />
      );
    },
  },
  // { field: "fields", headerName: "Fields", width: 150 },
  { field: "createdUser", headerName: "Requested By", width: 200 },
  { field: "created_on", headerName: "Requested On", width: 200 },
  {
    field: "approval_level_1_name",
    headerName: "SOGO Name",
    width: 200,
    renderCell: (params) => {
      const level1 = params.row.approvals?.find((a) => a.approval_level === 1);
      return level1 ? level1.approvedUser : "N/A";
    },
  },
  {
    field: "approval_level_1_status",
    headerName: "SOGO Approval Status",
    width: 200,
    renderCell: (params) => {
      const level1 = params.row.approvals?.find((a) => a.approval_level === 1);
      return level1 ? (
        <Chip
          label={level1.approvalStatus}
          color={"primary"}
          variant="outlined"
        />
      ) : (
        "N/A"
      );
    },
  },
  {
    field: "approval_level_1_on",
    headerName: "SOGO Approved On",
    width: 200,
    renderCell: (params) => {
      const level1 = params.row.approvals?.find((a) => a.approval_level === 1);
      if (level1?.request_approval_on === null) {
        return "N/A";
      } else {
        return level1?.request_approval_on;
      }
    },
  },
  {
    field: "approval_level_1_remarks",
    headerName: "SOGO Remarks",
    width: 200,
    renderCell: (params) => {
      const level1 = params.row.approvals?.find((a) => a.approval_level === 1);
      if (level1?.approval_remarks === null) {
        return "N/A";
      } else {
        return (
          <ToolTip
            content={level1?.approval_remarks}
            expand={level1?.approval_remarks}
          />
        );
      }
    },
  },
  {
    field: "approval_level_2_name",
    headerName: "Approval from Finance",
    width: 200,
    renderCell: (params) => {
      const level2 = params.row.approvals?.find((a) => a.approval_level === 2);
      return level2 ? level2.approvedUser : "N/A";
    },
  },
  {
    field: "approval_level_2_status",
    headerName: "Finance Approval Status",
    width: 200,
    renderCell: (params) => {
      const level2 = params.row.approvals?.find((a) => a.approval_level === 2);
      return level2 ? (
        <Chip
          label={level2.approvalStatus}
          color={"primary"}
          variant="outlined"
        />
      ) : (
        "N/A"
      );
    },
  },
  {
    field: "approval_level_2_on",
    headerName: "Finance Approved On",
    width: 200,
    renderCell: (params) => {
      const level2 = params.row.approvals?.find((a) => a.approval_level === 2);
      if (level2?.request_approval_on === null) {
        return "N/A";
      } else {
        return level2?.request_approval_on;
      }
    },
  },
  {
    field: "approval_level_2_remarks",
    headerName: "Finance Remarks",
    width: 200,
    renderCell: (params) => {
      const level2 = params.row.approvals?.find((a) => a.approval_level === 2);
      if (level2?.approval_remarks === null) {
        return "N/A";
      } else {
        return (
          <ToolTip
            content={level2?.approval_remarks}
            expand={level2?.approval_remarks}
          />
        );
      }
    },
  },
];
